/* eslint-disable
    func-names,
    no-shadow,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
// Collection of all Document.
const factory = function (BenchEvent, GatewayApi, Collection, $window, ClientFilters, _) {
  let BenchEventCollection;
  return (BenchEventCollection = (function () {
    BenchEventCollection = class BenchEventCollection extends Collection {
      static initClass() {
        this.prototype.$type = BenchEvent;
        this.prototype.$apiService = GatewayApi;
        this.prototype.$$cacheModels = true;

        this.prototype.eventType = 'actionables';
        this.prototype.viewerId = null;
        this.prototype.accountantId = null;
        this.prototype.bookkeeperId = null;
        this.prototype.bookkeeper2Id = null;
        this.prototype.salespersonId = null;
        this.prototype.salesperson2Id = null;
        this.prototype.fetchStats = true;
        this.prototype.fetchFlags = true;
        this.prototype.useFilters = false;
        this.prototype.preview = false;
        this.prototype.group = 'BENCH';
        this.prototype.cids = this.cids;
        this.prototype.inboxState = [];

        this.prototype.$idSerializers = [
          'accountantId',
          'bookkeeperId',
          'bookkeeper2Id',
          'full',
          'stats',
          'useFilters',
          'cids',
          'strictAssignmentMatching',
          'group',
          'names',
          'fetchStats',
          'fetchFlags',
          'cids',
        ];

        this.prototype.$paramNames = {
          viewerId: 'viewerId',
          accountantId: 'accountantId',
          bookkeeper2Id: 'bookkeeper2Id',
          salespersonId: 'salespersonId',
          salesperson2Id: 'salesperson2Id',
          fetchStats: 'fetchStats',
          fetchFlags: 'fetchFlags',
          preview: 'preview',
          group: 'group',
          cids: 'cids',
          useFilters: 'useFilters',
          strictAssignmentMatching: 'strictAssignmentMatching',
          names: 'names',
          inboxState() {
            return this.inboxState.join(',');
          },
        };
      }

      $filters() {
        return new ClientFilters(this.viewerId);
      }

      $init(data) {
        const filters = this.$filters();

        this.$set(_.defaults(data, filters.$data()));

        filters.$onSet(() => {
          this.$set(filters.$data());
          this.$empty();
          return this.$fetch();
        });

        return super.$init();
      }

      $url() {
        return `${this.eventType}/bk/${this.viewerId}`;
      }

      $deleteByIds(eventName, ids) {
        return GatewayApi.request({
          method: 'DELETE',
          url: `${this.eventType}/${this.viewerId}/resources/${ids.join()}/${eventName}`,
          params: {
            group: this.group,
          },
        });
      }

      $getClientEventCount(personId) {
        const client = this.$find({ personId });

        if (!client) {
          return 0;
        }

        let previews;
        if (
          typeof client !== 'undefined' &&
          client !== null &&
          'events' in client &&
          typeof client.events !== 'undefined'
        ) {
          ({ previews } = client.events);
        }

        return _.reduce(previews, (count, preview) => count + preview.counter, 0);
      }
    };
    BenchEventCollection.initClass();
    return BenchEventCollection;
  })());
};

const moduleDeps = [
  require('data/model/benchEvent').name,
  require('data/model/clientFilters').name,
  require('data/util').name,
];

module.exports = angular
  .module('bench.data.collection.benchEvent', moduleDeps)
  .factory('BenchEventCollection', factory);
